import Model from './Model'

export default class PermissionGroup extends Model {
  resource () { return 'permissiongroups' }
}
